import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome,faAngleRight } from '@fortawesome/free-solid-svg-icons';
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import Courseschedule from '../Landing/Subcomponent/courseschedule';

class Blacksix extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">    <Link href=""><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        <li class="breadcrumb-item active"> Six Sigma Black Belt Certification</li>
                    </ol>
                </div>
                <section class="course-header bg-black11" id="course-header">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5" style={{// eslint-disable-next-line
                            backgroundImage: "url(" + "/assets/images/icons/six-sigma-bkg/six-sigma-symbol.svg" + ")",
                        }}>
                            <h1>Six Sigma Black Belt Certification</h1> <br />
                            <br />
                            <br />
                            <div class="form-group">
                                <a href="#apply-nows" class="btn btn-md enroll-btn">Enroll Now </a>
                                <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                    data-target="#myModal" onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/six-sigma-black-belt-certification-program');">Download
                                 brochure</button>
                            </div>
                            <br /> <br /><h3> Online Live Training</h3><br /> <br />
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                            <p>Certification jointly awarded by</p>
                            <ul>
                                <li><img alt="executive" width="" src="/assets/images/isi.svg" />  </li>
                                <li><img alt="executive" width="" src="/assets/images/epn.svg" /></li>
                            </ul>
                            <br />
                        </div>

                    </div>
                </section>
                <div class="course-main-contains def-z" id="Description">
                    <div class="card">
                        <div class="row contanint-display">
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" >
                                <b>Schedule: </b><br />
                                <b> <i class="fa fa-calendar" ></i>&nbsp; Upto 12 Days</b><br />
                                <b class="font-for-batch">(Customisable as per requirements)</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-12">
                                <span class="golden">Training Mode(Online)</span><br />
                                <b> <span class="font-for-batch"><i class="fa fa-calendar-o" aria-hidden="true"></i>  Date :30<sup>th</sup> Jan 2020-07<sup>th</sup> Mar 2021 </span></b> <br />
                                <b><span class="font-for-batch"><i class="fa fa-film" aria-hidden="true"></i>  Batch Type :Saturday-Sunday </span></b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-12">
                                <span class="golden">Training Mode(Online)</span><br />
                                <b> <span class="font-for-batch"><i class="fa fa-calendar-o" aria-hidden="true"></i>  Date :18<sup>th</sup> Mar 2021-02<sup>nd</sup> April 2021</span></b> <br />
                                <b><span class="font-for-batch"><i class="fa fa-film" aria-hidden="true"></i>  Batch Type :Monday-Friday </span></b>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="def-z">
                    <div class="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#Features">Features </a></li>
                            <li><a href="#syllabus">Syllabus</a></li>
                            <li><a href="#Schedule">Schedule</a></li>
                            <li><a href="#Review-s">Learner Review </a></li>
                            <li><a href="#Certification-s">Certification</a></li>
                            <li class="btn-header cs-dx"><a href="#apply-nows">Enroll Now</a></li>
                        </ul>
                    </div>
                </section>
                <br />
                <section class="course-description" id="course-description">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="heading-tab">An Overview Of The Six Sigma Black Belt Course</h3>
                            <p align="justify" >The six sigma black belt certification is a program where participants will complete one Six Sigma project after the training and acquire transferable problem-solving skills and competence to solve and guide many problems in the forthcoming years for an organization.</p>
                            <p align="justify">The online six sigma black belt certification provides a very thorough understanding of Lean Six Sigma concepts in a heterogeneous setup and gives an in-depth understanding of statistical tools and techniques for effective fact based decision making. Six Sigma is a fact-based, data-driven structured methodology that is used to create breakthrough improvements in business processes. It is used to solve organizational problems where the solution is not known.<span id="Features"></span> The program augments the participant's existing domain knowledge and expertise with statistical thinking and application. This will help them to channelize their efforts and knowledge in the right direction and achieve groundbreaking results in their field.</p>
                            <p align="justify" >Proper assistance will be provided to the participants during their first Six Sigma project where they will be walked through the entire project. The students will get a holistic understanding while doing the project and will also get practice on how to work on future projects. The undertakers of the six sigma black belt course in Pune will be jointly certified by the renowned institute of Edu plus now, Pune in association with Indian Statistical Institute, Pune.</p>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="heading-tab">Key Features Of Six Sigma Black Belt Course</h3>
                         Now you can get the best six sigma black belt certification course in India from the comfort of your homes -
                         <p align="justify">
                                <ul class="highlight-ss">
                                    <li>	Indian Statistical Institute, Pune as a knowledge partner.</li>
                                    <li>	Mentorship by industry specialists.</li>
                                    <li>	Seamless EMI options.</li>
                                    <li>	Industry-oriented curriculum.</li>
                                    <li>	Course awarded by Edu Plus Now and Indian Statistical Institute, Pune.</li>
                                </ul>
                            </p>
                        </div>
                        <div class="col-1"> </div>
                    </div>
                    <br />
                    <h3 class="heading-tab"> Who Will Benefit From The Six Sigma Black Belt Course? </h3>
                    <div class="col-md-12 col-sm-12">
                        <ul class="highlight-ss">
                            <li>	This six sigma black belt certification course is suitable for people who are top executives, senior managers, team leaders, project managers, and management professionals.</li>
                            <li>	Anyone who is a transactional process leader of any discipline from any industry can attend the course.</li>
                            <li>	Entrepreneurs will find this course highly beneficial.</li>
                            <li>	People who work in the middle management can enrol themselves for the course.</li>
                            <li>	Software professionals and quality assurance engineers can also enrol themselves for this course.</li>
                        </ul>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <h3 class="heading-tab"> Career Options After Attaining This Online Six Sigma Black Belt Training </h3>
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-sm-6">
                            <ul class="highlight-ss">
                                <li>		Quality Improvement Specialist</li>
                                <li>	Lean Six Sigma Manager</li>
                                <li>		Six Sigma Lean Coordinator</li>
                                <li>		Senior Manager - Lean Six Sigma</li>
                                <li>		Senior SQE Manager</li>
                                <li>		Business Process Engineer</li>
                                <li>		Manager - Process Excellence</li>
                                <li>		Sr. Procurement Specialist</li>
                                <li>		Business Operations Analyst</li>
                                <li>		Finance Business Process Expert</li>
                                <li>		Six Sigma Black Belt Certified - Senior Specialist</li>
                                <li>		Quality Compliance Analyst</li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <ul class="highlight-ss">
                                <li>		Senior Manager Process Excellence</li>
                                <li>		Quality Assurance Manager</li>
                                <li>		Senior Business Process Improvement Manager</li>
                                <li>		Manager - Business Excellence</li>
                                <li>		Deputy General Manager - Process Excellence </li>
                                <li>		Project Improvement Manager</li>
                                <li>		Operations Project head</li>
                                <li>		Process Improvement Manager</li>
                                <li>		Head of Quality Assurance</li>
                                <li id="syllabus">		Six Sigma Black Belt Instructor</li>
                                <li>		AVP - Quality</li>
                                <li>		Six Sigma Process Consultant</li>
                                <li>		Operations Director</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section class="course-syllabus bg-secondary" id="course-syllabus">

                    <div class="row">
                        <div class="col-sm-12 ">
                            <h3>What Will You Learn In Six Sigma Black Belt Certification Course</h3>
                        The six sigma black belt certification training is divided into 5 modules that mainly come in handy for Six Sigma practitioners
                        <div id="de_syllabus">
                                <div class="panel-group">
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                            href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                            <h6 class="panel-title">{// eslint-disable-next-line
                                            }<a><i class="indicator fa fa-minus"></i> Recognize & Define</a>
                                            </h6>
                                        </div>
                                        <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                            data-parent="#de_syllabus">
                                            <div class="panel-body">
                                                <ul class="syllabus-ul" >
                                                    <li> Deployment of Six Sigma in organization, Organization hierarchy for
                                                    Six Sigma, Project Hopper, Project Charter, Voice of Customer,
                                                    Critical to Quality, Tree Diagram, Pareto, SIPOC </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                            href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                            <h6 class="panel-title">{// eslint-disable-next-line
                                            }<a><i class="indicator fa fa-minus"></i>Measure</a>
                                            </h6>
                                        </div>
                                        <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                            data-parent="#de_syllabus">
                                            <div class="panel-body">
                                                <ul class="syllabus-ul" >
                                                    <li> Type of Data, Measurement System Analysis – Variable & Attribute,
                                                    R&R Study, Sampling, Base level
                                                    Assessment, Normality tests, Capability analysis – Cp, Cpk,Pp, Ppk,
                                                    Defect & defective, DPMO, DPO,DPU, Sigma Level
                                                </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                            href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                            <h6 class="panel-title">{// eslint-disable-next-line
                                            } <a><i class="indicator fa fa-minus"></i>Analysis</a>
                                            </h6>
                                        </div>
                                        <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                            data-parent="#de_syllabus">
                                            <div class="panel-body">
                                                <ul class="syllabus-ul" >
                                                    <li>Process Analysis, Problem Analysis, Control Charts, Test of
                                                    Hypothesis, Tabular Analysis, Chi – Square
                                                    test, Regression Analysis, Process FMEA, Real cause identification
                                                </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                            href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                            <h6 class="panel-title">{// eslint-disable-next-line
                                            } <a><i class="indicator fa fa-minus"></i>Improve</a>
                                            </h6>
                                        </div>
                                        <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                            data-parent="#de_syllabus">
                                            <div class="panel-body">
                                                <ul class="syllabus-ul" >
                                                    <li>TRIZ, Solution Prioritization matrix, Solution Matrix, RICI – Chart,
                                                    Before After tests, Solution
                                                    Implementation, Design of Experiments - Taguchi, ANOVA
                                                </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="dv_heading5" data-toggle="collapse"
                                            href="#dv_syllabus5" aria-expanded="true" aria-controls="dv_syllabus5">
                                            <h6 class="panel-title">{// eslint-disable-next-line
                                            } <a><i class="indicator fa fa-minus"></i> Control </a>
                                            </h6>
                                        </div>
                                        <div id="dv_syllabus5" class="collapse show" aria-labelledby="dv_heading5"
                                            data-parent="#dv_syllabus">
                                            <div class="panel-body">
                                                <ul class="syllabus-ul" >
                                                    <li> Control Plan, Control Charts for Online Analysis, Mistake Proofing,
                                                    Kaizen Philosophy, Overall Review,
                                                    Evaluation Test
                                                </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-5">
                        </div>
                    </div>
                </section>
                <section class="course-admission-process bg-white" id="course-admission-process">
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <h3 class="heading-tab"> Skill One Must Possess For Having A Successful Career As A Six Sigma Practitioner </h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <ul class="highlight-ss">
                                <li>	Having a positive and optimistic attitude.</li>
                                <li>Possessing a firm belief in completing the tasks and achieving the goals.</li>
                                <li>	Keen and possessing the ability to take initiatives.</li>
                                <li>	Having excellent analytical and problem-solving skills.</li>
                                <li>	Having the ability to manage project teams.</li>
                                <li>	Being able to motivate peers.</li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <ul class="highlight-ss">
                                <li>	Having excellent communication skills.</li>
                                <li>	Having good writing skills and being able to present them.</li>
                                <li id="Schedule">	Possessing the know-how and understanding of business processes.</li>
                                <li>	Having the ability to manage budgets.</li>
                                <li>	Being able to allocate company resources optimally.</li>
                                <li>	Be hard-working and result-oriented.</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <Courseschedule />
                <Aboutuslearners />
                <Aluminicompany />
                <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3>Exam and Certification</h3>
                            <br />
                            <ul >
                                <li>Six Sigma Black Belt Certificate will be issued after the participants completes a Six Sigma project and attains<FontAwesomeIcon icon={faAngleRight} />=70% marks in the test conducted on the last day of the program. </li>
                                <br /><li>Once the candidate has attained all the above criteria for certification, he/she will be awarded the certificate of participation.</li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <img alt="Six Sigma Black Belt Certification" src="/assets/images/icons/certificate-final.png" />
                            <br /><br />
                            <p class="img-below-text text-center" id="apply-nows">Awarded Jointly by The Indian Statistical Institute,Pune and
                             edu plus now </p>
                            <br /><br />
                        </div>
                        <br />
                    </div>
                </section>
                <section class="courses-feesm">
                    <section class="course-fees" id="course-fees">
                        <div class="row box-sh" >
                            <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                            </div>
                            <div class="vertical-line-fee"> </div>
                            <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                <div class="row">
                                    <div class="col-sm-10"> <br /><br />
                                        <h5>Features</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <ul class="highlight-ss" >
                                            <li>	Indian Statistical Institute, Pune as a knowledge partner.</li>
                                            <li>	Mentorship by industry specialists.</li>
                                            <li>	Seamless EMI options.</li>
                                            <li>	Industry-oriented curriculum.</li>
                                            <li>	Course awarded by Edu Plus Now and Indian Statistical Institute, Pune.</li>
                                        </ul>
                                    </div>
                                    <p>{// eslint-disable-next-line
                                    }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 " > &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <Whyedu />
                <section class="course-about-instructor bg-secondary " id="course-about-instructor">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>About the Organization</h3>
                            <br />
                            <img alt="black3" width="" src="/assets/images/isi-black.svg" />
                            <br /><br />
                            <p align="justify">It is a Central Government institute, devoted to research, teaching & application of
                            not only statistics and allied sciences, but also the natural sciences, social
                            sciences and their interface with the statistics. Founded by Professor P.C.
                            Mahalanobis in Kolkata on 17th December, 1931, the institute gained the status of
                            an Institution of National Importance by an act of the Indian Parliament in 1959.
                                 </p>

                            <br />
                            <p align="justify">ISI Pune is a unit of Indian Statistical Institute,Pune, active in Teaching, Training,
                            Research and Consulting on application of statistics, operations research & allied
                            science to solve problems of the industry across the spread and depth of the
                            industries. ISI Pune bring sanctity of statistics in the mother initiatives such as
                            TQM, TPM, Six Sigma, Quality Management, Management Systems, Business Management,
                                     Data Analytic, Data Science. </p>
                        </div>
                    </div>
                </section>
                <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
                 <div class="modal-dialog modal-md">
                     <div class="modal-content">
                         <div class="modal-header" >
                             <span class="close" id="close_form" data-dismiss="modal">&times;</span>
                            <br />
                         </div>
                         <div class="modal-body" >
                             <div class="panel panel-default paper-shadow box_detail" >
                                 <h5 class="text-center "> Download The Course Brochure </h5>
                                 <form method="post" class="form-row"  onsubmit="return validate()">
                                     <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                         required="" autocomplete="on" name="name" id="name" />
                                     <b>Your email</b><input class="form-control" type="email" required=""
                                         autocomplete="on" name="emaill" id="emaill" />
                                     <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                         type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                     <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                                     <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                     <br />
                                     <div>
                                         <div class="form-group">
                                         <div  id="recaptcha" class="g-recaptcha"
                                             data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                             <div id="captcha"></div>
                                         </div>
                                     </div>
                                     <div class="mob_cb" >
                                         <div>
                                         </div><br />
                                          <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button></div>
                                     <br />
                                 </form>
                             </div>
                         </div>
                     </div>

                 </div>

             </div>
            </div>
        );
    }
}

export default Blacksix;